import styled from "@emotion/styled";

export const Small = styled.small`
  color: var(--text-light);
`;
